import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import SweetAlert from 'react-bootstrap-sweetalert';
import 'moment/locale/pt-br';
import api from '../../../services/api';

import Loading from '../../../components/Loading';
import { Container, ButtonPanel } from './styles';
import 'react-image-crop/dist/ReactCrop.css';
import Input from '../../../components/Input';

export default class AddAdministrator extends Component {
  state = {
    alert: {},
    email: null,
    name: null,
    password: null,
    showAlert: false,
    loading: false,
  };

  static propTypes = {
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    location: PropTypes.shape({
      search: PropTypes.string,
    }).isRequired,
  };

  handleSubmit = async (e) => {
    const {
      email,
      name,
      password,
    } = this.state;

    e.preventDefault();

    this.setState({ loading: true });
    try {
      await api.post('admins/create', {
        admin: {
          email,
          name,
          password,
        },
      }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_admin')}`,
        },
      });
      this.props.history.push('/admin/dashboard/administrators');
    } catch (err) {
      this.setState({ loading: false });
      const messages = err.response && err.response.data && err.response.data.errors
        ? err.response.data.errors
        : ['Não foi possível completar a requisição. Por favor, atualize a página.'];
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages,
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  openAlert = () => {
    this.setState({
      showAlert: true,
    });
  };

  closeAlert = () => {
    this.setState({
      showAlert: false,
    });
  };

  onConfirm = () => {
    this.setState({
      showAlert: false,
    });
  };

  render() {
    const {
      alert: {
        cancelBtnText,
        cancelBtnBsStyle,
        confirmBtnText,
        confirmBtnBsStyle,
        messages,
        onConfirm,
        showCancel,
        title,
        type,
      },
      email,
      loading,
      name,
      password,
      showAlert,
    } = this.state;

    return (
      <Fragment>
        {loading && <Loading />}
        <Container>
          <h1 className="page-title">Criar administrador</h1>
          <div className="box">
            <form onSubmit={this.handleSubmit}>
              <div className="row">
                <div className="col-sm-6">
                  <Input
                    name="name"
                    value={name}
                    onChange={this.handleChange}
                    placeholder="Nome"
                  />
                  <Input
                    name="email"
                    value={email}
                    onChange={this.handleChange}
                    placeholder="Email"
                  />
                  <Input
                    name="password"
                    type="password"
                    value={password}
                    onChange={this.handleChange}
                    placeholder="Senha"
                  />
                </div>
                <div className="col-12">
                  <ButtonPanel>
                    <Link to="/admin/dashboard/administrators" className="btn btn-light">
                      Cancelar
                    </Link>
                    <input type="submit" className="btn btn-success" value="Salvar" />
                  </ButtonPanel>
                </div>
              </div>
            </form>
          </div>
          {showAlert && (
            <SweetAlert
              type={type}
              confirmBtnText={confirmBtnText}
              confirmBtnBsStyle={confirmBtnBsStyle}
              showCancel={showCancel}
              cancelBtnText={cancelBtnText}
              cancelBtnBsStyle={cancelBtnBsStyle}
              title={title}
              onConfirm={onConfirm}
              onCancel={this.closeAlert}
            >
              <ul>
                {messages.map(msg => (
                  <li key={msg}>{msg}</li>
                ))}
              </ul>
            </SweetAlert>
          )}
        </Container>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/pages/AddAdministrator/index.js